import { type DevScenarioEntry, devScenarioEntry, mockApiError } from '@arya/shared/msw-cloudflare';

const WITHDRAW = { method: 'POST', path: '/api/account/withdrawals' } as const;
const EXCHANGE = { method: 'POST', path: '/api/account/wallet/exchange' } as const;
const WALLET_SCREEN = '/account/wallet';

export const WALLET_SCENARIOS: readonly DevScenarioEntry[] = [
  devScenarioEntry(
    {
      name: 'wallet-500',
      group: 'Wallet',
      title: 'Server error',
      description: 'The wallet fails to load: error banner with Try again.',
      screen: WALLET_SCREEN,
    },
    { method: 'GET', path: '/api/account/wallet' },
    () => mockApiError(500, 'boom')
  ),
  devScenarioEntry(
    {
      name: 'wallet-activity-500',
      group: 'Wallet transactions',
      title: 'Server error',
      description: 'The transaction list fails to load: error banner with Try again.',
      screen: WALLET_SCREEN,
    },
    { method: 'GET', path: '/api/account/wallet/activity' },
    () => mockApiError(500, 'boom')
  ),
  devScenarioEntry(
    {
      name: 'deposit-details-500',
      group: 'Deposit',
      title: 'Bank details unavailable',
      description: 'The deposit dialog cannot show the bank details.',
      screen: `${WALLET_SCREEN}?dialog=deposit`,
    },
    { method: 'GET', path: '/api/account/wallet/deposit-instructions' },
    () => mockApiError(500, 'boom')
  ),
  devScenarioEntry(
    {
      name: 'withdraw-cooldown',
      group: 'Withdraw',
      title: 'Contact change cooldown',
      description: 'Confirming a withdrawal answers 423: paused after a contact detail change.',
      screen: `${WALLET_SCREEN}?dialog=withdraw`,
    },
    WITHDRAW,
    () =>
      mockApiError(423, 'Withdrawals are paused after a contact change', {
        reason: 'contact_change_cooldown',
        freezeEndsAt: new Date(Date.now() + 24 * 3_600_000).toISOString(),
      })
  ),
  devScenarioEntry(
    {
      name: 'withdraw-frozen',
      group: 'Withdraw',
      title: 'Account frozen',
      description: 'Confirming a withdrawal answers 423: the account is frozen.',
      screen: `${WALLET_SCREEN}?dialog=withdraw`,
    },
    WITHDRAW,
    () => mockApiError(423, 'Account is frozen', { reason: 'account_frozen' })
  ),
  devScenarioEntry(
    {
      name: 'withdraw-unverified-account',
      group: 'Withdraw',
      title: 'Bank account not verified',
      description: 'Confirming a withdrawal answers 409: the bank account is still being verified.',
      screen: `${WALLET_SCREEN}?dialog=withdraw`,
    },
    WITHDRAW,
    () => mockApiError(409, 'Bank account is not verified', { reason: 'bank_account_not_verified' })
  ),
  devScenarioEntry(
    {
      name: 'exchange-rate-changed',
      group: 'Exchange',
      title: 'Rate changed',
      description: 'Confirming an exchange answers 409: the quoted rate moved.',
      screen: `${WALLET_SCREEN}?dialog=exchange`,
    },
    EXCHANGE,
    () => mockApiError(409, 'Rate changed', { reason: 'rate_mismatch' })
  ),
  devScenarioEntry(
    {
      name: 'exchange-rate-unavailable',
      group: 'Exchange',
      title: 'Rate unavailable',
      description: 'Confirming an exchange answers 503: no rate right now.',
      screen: `${WALLET_SCREEN}?dialog=exchange`,
    },
    EXCHANGE,
    () => mockApiError(503, 'Rate unavailable', { reason: 'rate_unavailable' })
  ),
  devScenarioEntry(
    {
      name: 'statements-500',
      group: 'Statements',
      title: 'Server error',
      description: 'The statements list fails to load: error with Try again.',
      screen: '/account/statements',
    },
    { method: 'GET', path: '/api/account/wallet/statements' },
    () => mockApiError(500, 'boom')
  ),
];
